import isNumeric from './isNumeric';

export default function makeAverage (arr: number[], fixedAmount = 1) {
  const average = +(arr.reduce((a: number, b: number) => a + b, 0) / arr.length).toFixed(fixedAmount);

  return isNumeric(average) ? average : 0;
}
